export enum SubscriptionModuleEnum {
    MOBILE_APP = 'MOBILE_APP',
    KDS_APP = 'KDS_APP',
    KIOSK = 'KIOSK',
    QR_MENU = 'QR_MENU',
    TABLE_ORDERS = 'TABLE_ORDERS',
    PROMO_CODES = 'PROMO_CODES',
    LOYALTY_PROGRAM = 'LOYALTY_PROGRAM',
    RESTAURANT_LIMIT = 'RESTAURANT_LIMIT',
    FISCALIZATION = 'FISCALIZATION',
    STOCK = 'STOCK',
    WEBSITE = 'WEBSITE',
    INVENTORY = 'INVENTORY',
    QR_MENU_TABLE_ORDER = 'QR_MENU_TABLE_ORDER',
    KDS = 'KDS',
    LOYALTY_PROMO_CODES = 'LOYALTY_PROMO_CODES',
    COURIERS = 'COURIERS',
    DRIVER = 'DRIVER',
    ASHBURN = 'ASHBURN',
    ERP = 'ERP',
}
